exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lignes-facture .datatable-body-cell {\n  padding: 0 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/eveasoft/lea/lea-front/src/app/shared/facture/create/create.component.scss
// module id = ../../../../../src/app/shared/facture/create/create.component.scss
// module chunks = main